/* ============================================================
   CRAZXY Effects — Shopify Asset
   1. Rainbow paint dot trail (desktop only) — no spray can, normal cursor
   2. Click burst splat
   3. Promo banner (rotating promotions)
   4. Scroll reveal (.crazxy-reveal elements)
   ============================================================ */

(function () {
  'use strict';

  /* ── 1. SCROLL REVEAL ───────────────────────────────────── */
  var _scrollRevealObserver = null;

  function initScrollReveal() {
    var els = document.querySelectorAll('.crazxy-reveal');
    if (!els.length) return;

    /* Disconnect any previous observer (safe to re-call on bfcache restore) */
    if (_scrollRevealObserver) {
      _scrollRevealObserver.disconnect();
      _scrollRevealObserver = null;
    }

    /* On bfcache restore: reset is-visible so off-screen items re-animate in */
    var vp = window.innerHeight || document.documentElement.clientHeight;
    els.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.top >= vp) {
        el.classList.remove('is-visible');
      }
    });

    /* Immediately reveal any elements already in the viewport */
    els.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < vp) {
        el.classList.add('is-visible');
      }
    });

    _scrollRevealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          _scrollRevealObserver.unobserve(e.target);
        }
      });
    }, { threshold: 0.05 });

    els.forEach(function (el) {
      if (!el.classList.contains('is-visible')) {
        _scrollRevealObserver.observe(el);
      }
    });
  }

  /* ── 2. PAINT DOT TRAIL + CLICK BURST ──────────────────── */
  var RAINBOW = ['#FF006E','#FF9F1C','#FFDD00','#06D6A0','#4361EE','#7B2FBE','#E63946'];
  var TRAIL_LENGTH = 8;
  var dotCounter = 0;
  var trailDots = [];
  var lastTrailX = -999, lastTrailY = -999;

  function initPaintTrail() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    if (!document.getElementById('crazxy-dot-style')) {
      var s = document.createElement('style');
      s.id = 'crazxy-dot-style';
      s.textContent = '@keyframes crazxy-dot-fade{0%{opacity:.9;transform:scale(1)}100%{opacity:0;transform:scale(.2)}}';
      document.head.appendChild(s);
    }

    window.addEventListener('mousemove', function (e) {
      var dx = e.clientX - lastTrailX;
      var dy = e.clientY - lastTrailY;
      if (Math.sqrt(dx * dx + dy * dy) < 16) return;
      lastTrailX = e.clientX;
      lastTrailY = e.clientY;

      var color = RAINBOW[dotCounter % RAINBOW.length];
      var size  = 7 + Math.random() * 6;
      var dot   = document.createElement('div');
      dot.style.cssText = [
        'position:fixed',
        'pointer-events:none',
        'z-index:9997',
        'border-radius:50% 50% 50% 50% / 60% 60% 40% 40%',
        'left:' + (e.clientX - size / 2) + 'px',
        'top:'  + (e.clientY - size / 2) + 'px',
        'width:' + size + 'px',
        'height:' + (size * 1.35) + 'px',
        'background:' + color,
        'box-shadow:0 0 5px ' + color + '99',
        'transform:rotate(' + (Math.random() * 30 - 15) + 'deg)',
        'animation:crazxy-dot-fade 0.7s ease-out forwards'
      ].join(';');
      document.body.appendChild(dot);
      trailDots.push(dot);
      dotCounter++;

      if (trailDots.length > TRAIL_LENGTH) {
        var old = trailDots.shift();
        if (old && old.parentNode) old.parentNode.removeChild(old);
      }

      dot.addEventListener('animationend', function () {
        if (dot.parentNode) dot.parentNode.removeChild(dot);
        var idx = trailDots.indexOf(dot);
        if (idx > -1) trailDots.splice(idx, 1);
      });
    });

    /* Click burst splat — desktop only (touch devices don't need DOM splat particles) */
    window.addEventListener('click', function (e) {
      if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
      for (var i = 0; i < 12; i++) {
        var angle = (i / 12) * Math.PI * 2 + Math.random() * 0.4;
        var speed = 20 + Math.random() * 28;
        var color = RAINBOW[(dotCounter + i) % RAINBOW.length];
        var size  = 6 + Math.random() * 5;
        var splat = document.createElement('div');
        splat.style.cssText = [
          'position:fixed',
          'pointer-events:none',
          'z-index:9997',
          'border-radius:50%',
          'left:' + (e.clientX + Math.cos(angle) * speed - size / 2) + 'px',
          'top:'  + (e.clientY + Math.sin(angle) * speed - size / 2) + 'px',
          'width:' + size + 'px',
          'height:' + size + 'px',
          'background:' + color,
          'box-shadow:0 0 6px ' + color,
          'animation:crazxy-dot-fade 0.55s ease-out forwards'
        ].join(';');
        document.body.appendChild(splat);
        splat.addEventListener('animationend', function () {
          if (splat.parentNode) splat.parentNode.removeChild(splat);
        });
      }
    });
  }

  /* ── INIT ────────────────────────────────────────────────── */
  /* Note: promo banner is now handled by crazxy-promo-banner.liquid section */
  document.addEventListener('DOMContentLoaded', function () {
    initScrollReveal();
    initPaintTrail();
  });

  /* ── BFCACHE FIX ─────────────────────────────────────────── */
  /* When the user taps the mobile back button, the browser may restore
     the page from bfcache (back/forward cache) without firing
     DOMContentLoaded. Any .crazxy-reveal elements that hadn't yet
     received is-visible are stuck hidden. Re-running initScrollReveal
     on pageshow (persisted=true) fixes the missing product cards. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      /* Disconnect any stale observers then re-initialise */
      initScrollReveal();
    }
  });

  /* ── CRAZXY: Prevent invisible cart drawer from locking the page ──
     The Horizon cart-drawer-component listens for CartAddEvent and
     calls showDialog() which sets body{position:fixed}. Since we hide
     header-component, the drawer opens invisibly and the page stays
     locked. We intercept the event and immediately close any open
     dialog to release the body lock.
  ── */
  document.addEventListener('cart:update', function () {
    setTimeout(function () {
      var cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer && typeof cartDrawer.closeDialog === 'function') {
        cartDrawer.closeDialog();
      }
      // Safety net: if body got fixed, release it
      if (document.body.style.position === 'fixed') {
        var scrollY = Math.abs(parseInt(document.body.style.top || '0', 10));
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        window.scrollTo({ top: scrollY, behavior: 'instant' });
      }
    }, 50);
  }, true);

})();